import { useColorMode } from "@chakra-ui/react";

function AuditedIconV1() {
  const { colorMode } = useColorMode();

  if (colorMode === "dark") {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_5898_58654)">
          <path
            d="M8 0.666016L2 3.33268V7.33268C2 11.0327 4.56 14.4927 8 15.3327C11.44 14.4927 14 11.0327 14 7.33268V3.33268L8 0.666016ZM6.66667 11.3327L4 8.66602L4.94 7.72602L6.66667 9.44602L11.06 5.05268L12 5.99935L6.66667 11.3327Z"
            fill="#9AE6B4"
          />
        </g>
        <defs>
          <clipPath id="clip0_5898_58654">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 0.666504L0 3.33317V7.33317C0 11.0332 2.56 14.4932 6 15.3332C9.44 14.4932 12 11.0332 12 7.33317V3.33317L6 0.666504ZM4.66667 11.3332L2 8.6665L2.94 7.7265L4.66667 9.4465L9.06 5.05317L10 5.99984L4.66667 11.3332Z"
        fill="#38A169"
      />
    </svg>
  );
}

export default AuditedIconV1;
